export const CREATE_RESERVATION_START = 'CREATE_RESERVATION_START';
export const CREATE_RESERVATION_SUCCESS = 'CREATE_RESERVATION_SUCCESS';
export const CREATE_RESERVATION_FAILED = 'CREATE_RESERVATION_FAILED';

export const FETCH_RESERVATION_START = 'FETCH_RESERVATION_START';
export const FETCH_RESERVATION_SUCCESS = 'FETCH_RESERVATION_SUCCESS';
export const FETCH_RESERVATION_FAILED = 'FETCH_RESERVATION_FAILED';

export const RESET_CREATE_RESERVATION = 'RESET_CREATE_RESERVATION';
